module.exports = __webpack_public_path__ + "static/img/email.8448b5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/email.png
// module id = 1549
// module chunks = 0